import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/hr/me')({
  component: MeLayout,
})

function MeLayout() {
  return (
    <div className="container mx-auto py-6 px-4">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">My HR</h1>
        <p className="text-muted-foreground">View your own HR data.</p>
      </div>
      <Outlet />
    </div>
  )
}
